var isDev = window.location.hostname === 'localhost' || /(^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.)/.test(window.location.hostname)
var isPre = window.location.hostname === 'localhost'
var isTst = window.location.hostname === 'wwwtest.beathey.com'
var isStg = window.location.hostname === 'wwwdev.beathey.com'
var isProd = window.location.hostname === 'wwwprod.beathey.com'

var baseHost = `https://beathey.com`

var ppClientId = 'Abs7V6JtNPhBdHyXRPDH6aRuESQj4MhTSfi4MwH0mI0Nef5eyP07UtXUTZFXgZa5ztZp0XDu5Tu1oUCE'

if (isDev || isPre) {
  baseHost = `http://localhost`
  // Credenciales Sandbox para Paypal
  ppClientId = 'AVs9tKtUaY4iP7GSjBXbhWgSo13ewHgjEoy1ziR68bskWevz2B4G9byEwls-hXLfWci0_B3Lk4zHNklL'
} else if (isTst) {
  baseHost = `https://wwwtest.beathey.com`
  // Credenciales Sandbox para Paypal
  ppClientId = 'AVs9tKtUaY4iP7GSjBXbhWgSo13ewHgjEoy1ziR68bskWevz2B4G9byEwls-hXLfWci0_B3Lk4zHNklL'
} else if (isStg) {
  baseHost = `https://wwwdev.beathey.com`
} else if (isProd) {
  baseHost = `https://wwwprod.beathey.com`
}
var apiUrl = baseHost + '/services'

var ppSubscriptionPaymentURL = 'https://www.paypal.com/sdk/js?client-id=' + ppClientId + '&disable-funding=card&vault=true&intent=subscription'
var ppTrackPaymentURL = 'https://www.paypal.com/sdk/js?client-id=' + ppClientId + '&disable-funding=card'

export default {
  API_BASE_URL: apiUrl,
  BASE_HOST: baseHost,
  MEDIA_BASE_URL: baseHost,
  MUSIC_FAN_TYPE: 0,
  PRODUCER_TYPE: 1,
  ACCEPTED_LOCALES: ['es', 'en', 'pt'],
  DEFAULT_LOCALE: 'en',
  PP_SUBSCRIPTION_PAYMENT_URL: ppSubscriptionPaymentURL,
  PP_TRACK_PAYMENT_URL: ppTrackPaymentURL
}



// WEBPACK FOOTER //
// ./src/consts/index.js